import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { SpaceGroupsContainer } from 'src/features/space-groups/containers/space-groups';
import { meilisearchSearchSchema } from 'src/hooks/meilisearch/schema/meilisearch-search-schema';

export const Route = createFileRoute('/_layout/tenant/spaces/_layout/groups')({
  component: SpaceGroupsContainer,
  validateSearch: zodValidator(meilisearchSearchSchema),
});
